export default __webpack_public_path__ + "static/media/tfg-icon-active.c030e1b8.svg";